import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=1dd3f38e&scoped=true&"
import script from "./ProductSelect.vue?vue&type=script&lang=js&"
export * from "./ProductSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelect.vue?vue&type=style&index=0&id=1dd3f38e&prod&lang=less&scoped=true&"
import style1 from "./ProductSelect.vue?vue&type=style&index=1&id=1dd3f38e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd3f38e",
  null
  
)

export default component.exports